import React from 'react'

const ServicesBanner = () => {
    return (
        <section className="main">
            <div className="container">
                <div className="row">
                    <div className="flex flex-row items-center">
                        <div className="w-1/2">
                            <h2>We build exceptional products...</h2>
                        </div>
                        <div className="w-1/2">
                            <p className="splurge">No two projects are alike. The days of a development agency building websites are long-gone. Frontends, backends, authorisation, login &amp; log out, dynamic data, static data, API feeds, headless CMSs, static site generation or client side rendering.  We’ve got you covered all the way, from conception through to realisation, we’re there every step of the journey with you, and we’ll both love it.</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default ServicesBanner
